import { render, staticRenderFns } from "./SumupMajorNoScoreRateList.vue?vue&type=template&id=0c30e314&"
import script from "./SumupMajorNoScoreRateList.vue?vue&type=script&lang=ts&"
export * from "./SumupMajorNoScoreRateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports